// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WishListGroupModal-marginLeft-jlwgg{
    margin-left: 12px;
}
.WishListGroupModal-paddingTop-KDCtG{
    padding-top: 50px;
}
@media screen and (max-width: 767px) {
.WishListGroupModal-mobileBtn-MTFJl{
    width: 100%;
}
.WishListGroupModal-marginLeft-jlwgg{
    margin-left: 0;
    margin-top: 12px;
}
}`, "",{"version":3,"sources":["webpack://./src/components/WishLists/WishListGroupModal/WishListGroupModal.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA","sourcesContent":[".marginLeft{\n    margin-left: 12px;\n}\n.paddingTop{\n    padding-top: 50px;\n}\n@media screen and (max-width: 767px) {\n.mobileBtn{\n    width: 100%;\n}\n.marginLeft{\n    margin-left: 0;\n    margin-top: 12px;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"marginLeft": `WishListGroupModal-marginLeft-jlwgg`,
	"paddingTop": `WishListGroupModal-paddingTop-KDCtG`,
	"mobileBtn": `WishListGroupModal-mobileBtn-MTFJl`
};
module.exports = ___CSS_LOADER_EXPORT___;
